module.exports = __webpack_public_path__ + "c21845d1dd42fb7daa4628377ceaad7a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/favicons/apple_touch_icon_114x114.png
// module id = 309
// module chunks = 0